import axios from 'axios';

const mikeCouldAxios = axios.create({
  baseURL: 'https://api.mike-cloud-dev.com',
});
const defaultAxios = axios.create();

export default defaultAxios;
export { mikeCouldAxios, defaultAxios };
